export type SubscriptionPlan = 'free' | 'pro';

export type SubscriptionStatus =
  | 'active'
  | 'canceled'
  | 'past_due'
  | 'trialing'
  | 'incomplete';

export interface Subscription {
  id: string;
  userId: string;
  stripeCustomerId: string | null;
  stripeSubscriptionId: string | null;
  plan: SubscriptionPlan;
  status: SubscriptionStatus;
  currentPeriodStart: string | null;
  currentPeriodEnd: string | null;
  cancelAtPeriodEnd: boolean;
  gracePeriodEndsAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PlanFeature {
  key: string;
  free: boolean | string;
  pro: boolean | string;
}

export const PLAN_FEATURES: PlanFeature[] = [
  { key: 'premiumTemplates', free: false, pro: true },
  { key: 'pageLimit', free: '3', pro: 'unlimited' },
  { key: 'customDomain', free: false, pro: true },
  { key: 'prioritySupport', free: false, pro: true },
  { key: 'noBranding', free: false, pro: true },
  { key: 'googleAnalytics', free: false, pro: true },
];

export const FREE_PAGE_LIMIT = 3;
